import { render, staticRenderFns } from "./novel-add-or-update.vue?vue&type=template&id=61174641"
import script from "./novel-add-or-update.vue?vue&type=script&lang=js"
export * from "./novel-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./novel-add-or-update.vue?vue&type=style&index=0&id=61174641&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports